(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-start/assets/react/start-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-start/assets/react/start-page.js');

'use strict';

var _svs$lyckoplatsen$dat;
const {
  Debug
} = svs.tur.grid;
const {
  useEffect,
  useState
} = React;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  CharityContainer,
  Links
} = svs.lyckoplatsen.components.page_start.react.components;
const {
  Header,
  HeaderB
} = svs.lyckoplatsen.components.page_start.react.components;
const abTestStartPageHeader = (_svs$lyckoplatsen$dat = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat === void 0 ? void 0 : _svs$lyckoplatsen$dat.abTestStartPageHeader;
const StartPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);
  const isTargetB = abTestStartPageHeader === 'B';
  return React.createElement("div", {
    className: "lp-page-start ".concat(isLoaded ? 'page-loaded' : '')
  }, React.createElement(Debug, null), isTargetB ? React.createElement(HeaderB, null) : React.createElement(Header, null), React.createElement(WidgetArea, {
    areaName: "startPageTopWidgetArea",
    widgetArea: "startPageTopWidgetArea"
  }), React.createElement(CharityContainer, null), React.createElement(WidgetArea, {
    className: "start-bottom-widget-area",
    areaName: "startPageBottomWidgetArea",
    widgetArea: "startPageBottomWidgetArea"
  }), React.createElement(Links, null));
};
setGlobal('svs.lyckoplatsen.components.page_start.react', {
  StartPage
});

 })(window);